module.exports = __webpack_public_path__ + "img/图1-8  机器学习的一般过程.9b04b099.png";